import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  app: {
    position: 'relative',
    width: '100%',
    height: '100%',
    minHeight: 'calc(100vh - 16px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
  },
  appContent: {
    width: '100%',
    height: '100%',
    maxWidth: 500,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(0, 2),
  },
  appRow: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(0.5),
  },
  appCard: {
    width: '100%',
    fontSize: 14,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: theme.spacing(1),
    padding: theme.spacing(1),
    borderRadius: 8,
    border: `1px solid ${theme.palette.secondary.main}`,
    backgroundColor: theme.palette.background.paper,
    boxShadow:
      '0px 2px 4px -2px rgba(148, 158, 178, 0.12), 0px 4px 4px -2px rgba(148, 158, 178, 0.08)',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
  },
  appTab: {
    fontSize: 14,
    textTransform: 'none',
    '&.Mui-selected': {
      color: theme.palette.text.primary,
    },
    '&:not(.Mui-selected)': {
      color: theme.palette.text.secondary,
    },
  },
  appTitle: {
    fontSize: 16,
    whiteSpace: 'pre-wrap',
  },
  appText: {
    width: '100%',
    whiteSpace: 'pre-wrap',
    fontSize: 12,
  },
  appChip: {
    fontWeight: 600,
    fontSize: 12,
    whiteSpace: 'pre-wrap',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(0.5, 1),
    borderRadius: 12,
    border: `1px solid ${theme.palette.secondary.main}`,
    backgroundColor: theme.palette.background.paper,
    boxShadow:
      '0px 2px 4px -2px rgba(148, 158, 178, 0.12), 0px 4px 4px -2px rgba(148, 158, 178, 0.08)',
  },
  appLogo: {
    height: 100,
    pointerEvents: 'none',
    animation: '$appLogoSpin infinite 20s linear',
  },
  '@keyframes appLogoSpin': {
    from: {
      transform: 'rotate(0deg)',
    },
    to: {
      transform: 'rotate(360deg)',
    },
  },
}));
